<template lang="pug">
  div.wrap-module-license.f.fh
    div.license-content.py20
      div.mb20
        div.f.fc.mb24
          div.wrap-img
            v-img(src="/img/symbol.svg")
        h2.text-center.fz20 CERTIFICATE
        h2.text-center.fz20.mb20 OF HEALTHCARE CATALYST
        a(:href="adressURL" target="brank").block.fz14.mb8.text-center {{license.address}}
      div.mb10
        span.fz14.block.mb8 氏名：{{license.displayName}}
      
      div.f.mb16
        span.block.fz14.mr8 発効日：{{issuedDateStr}}
        span.block.fz14 失効日：{{expirationDateStr}}
      
      div.f.fc
        div(v-clipboard:copy="publicPageURL"
          v-clipboard:success="onCopy").wrap-page-url.f.fm
          v-icon(:color="pallete.$active_color").mr8 mdi-content-copy
          span.block.fz14.word-break-all {{publicPageURL}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-license {
  padding-top: $header_height;
  min-height: 100vh;
  .license-content {
    margin: 0 auto;
    width: $base_width_percent;
    max-width: 420px;
    // max-width: $base_max_width_px;
    .wrap-img {
      width: 120px;
    }
    .wrap-page-url {
      color: $active_color;
    }
  }
}
</style>

<script>
import { domain } from '@/components/utils/config'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import { format } from 'date-fns'

export default {
  components: {
  },
  props: {
    license: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    adressURL () {
      return `https://etherscan.io/address/${this.license.address}`
    },
    issuedDateStr () {
      return format(this.license.certifiedAt.toDate(), 'yyyy年M月d日')
    },
    expirationDateStr () {
      return format(this.license.expiredAt.toDate(), 'yyyy年M月d日')
    },
    publicPageURL () {
      return `${domain}/catalyst/${this.uid}`
    }
  },
  data () {
    return {
      
    }
  },
  methods: {
    onCopy () {
      alert(`URLをコピーしました。${this.publicPageURL}`)
    }
  }
}
</script>
